import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { Children, cloneElement, isValidElement } from 'react';

/**
 * `Tour` component is used for introducing a new functionality in the product.
 * The component consists of several [Spots](#!/Spot), each of them highlighting a specific feature
 * or element you want to focus user attention on.
 * @since 2.7.0
 */
var Tour = function Tour(_ref) {
  var current = _ref.current,
      children = _ref.children,
      onClose = _ref.onClose;
  var spots = Children.toArray(children);

  if (current !== undefined && current in spots) {
    var spot = spots[current];

    if (isValidElement(spot)) {
      var popup;

      if (onClose && spot.props.popup) {
        popup = _objectSpread({}, spot.props.popup, {
          onClose: onClose
        });
      }

      var props = {
        key: current,
        meta: {
          current: current,
          total: spots.length
        },
        popup: popup
      };
      return cloneElement(spot, props);
    }
  } // a workaround for Props & Methods in Styleguidist
  // eslint-disable-next-line no-constant-condition


  if (false) {
    return React.createElement("span", null);
  }

  return null;
};

export default Tour;